import React, { useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function Notfound() {
  const history = useHistory();
  useEffect(() => {
    history.push("/");
  }, [history]);
  return <></>;
}

export default Notfound;
